import type { FC } from "react";

const LayoutLoading: FC = () => {
  return (
    <div className="bg-[white] w-dvw h-dvh h-100 flex items-center justify-center">
      <div className="w-[120px] flex items-center gap-[12px] relative">
        <img src="/svg/krunsh-icon.svg" style={{ zIndex: 2 }} />
        <img
          style={{
            position: "absolute",
            left: 46,
            animation: "loading-layout 1.3s",
          }}
          src="/svg/krunsh.svg"
        />
      </div>
    </div>
  );
};

export default LayoutLoading;
